import Vue from 'vue';
import firebase from 'firebase/compat/app';
import 'firebase/compat/messaging';
import config from '@src/config';
import sendEvent from './utils/analytics';

export function initializeFirebase() {
  const firebaseConfig = config.FIREBASE;
  firebase.initializeApp(firebaseConfig);
}

export function getFCM() {
  const messaging = firebase.messaging.isSupported() ? firebase.messaging() : null;
  return messaging;
}

export async function enableAnalytics() {
  Vue.prototype.$sendEvent = sendEvent;
}

export async function requestNotificationPermission() {
  console.log('[App] Starting notification permission request...');

  // Check if Notification API is supported
  if (!('Notification' in window)) {
    console.log('[App] Notification API is not supported in this browser');
    return false;
  }

  try {
    console.log('[App] Current permission status:', Notification.permission);

    // If already granted, no need to request again
    if (Notification.permission === 'granted') {
      console.log('[App] Notification permission already granted');
      return true;
    }

    // If denied, we can't request again
    if (Notification.permission === 'denied') {
      console.log('[App] Notification permission was previously denied');
      return false;
    }

    // Request permission
    const permission = await Notification.requestPermission();
    console.log('[App] Permission request result:', permission);

    return permission === 'granted';
  } catch (error) {
    console.error('[App] Error requesting notification permission:', error);
    return false;
  }
}

export function isNotificationGranted() {
  console.log('[App] Checking notification permission status...');

  // Check if Notification API is supported
  if (!('Notification' in window)) {
    console.log('[App] Notification API is not supported in this browser');
    return false;
  }

  // Log notification API availability
  console.log('[App] Notification API support:', {
    standardNotification: !!window.Notification,
    mozNotification: !!window.mozNotification,
    webkitNotification: !!window.webkitNotification,
  });

  // Get the appropriate Notification object
  const NotificationAPI = window.Notification || window.mozNotification || window.webkitNotification;

  if (!NotificationAPI) {
    console.log('[App] No Notification API implementation found');
    return false;
  }

  // Log current permission state
  console.log('[App] Current notification permission:', NotificationAPI.permission);

  const isGranted = NotificationAPI.permission === 'granted';
  console.log('[App] Is notification permission granted:', isGranted);

  return isGranted;
}
